module.exports = __webpack_public_path__ + "static/img/10.5ddbf77.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/10.png
// module id = IVX7
// module chunks = 1